import { mapState } from 'vuex'

export default {
  data() {
    return {}
  },
  computed: {
    ...mapState('mobile', ['isMobile']),
  },
  methods: {
    getName(name) {
      let mass = name.split(' ')
      mass = mass.filter((item, index) => index < 2)
      let result = ''
      mass.forEach(item => {
        result = result + item.split('')[0]
      })
      return result
    },
  },
}



// WEBPACK FOOTER //
// ./src/templates/components/ui-components/builder/timeline-cases/component.js